"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCajaMediosPagoCampoExtra = exports.validateCajaMediosPago = exports.cajaMediosPagoConverter = void 0;
const cajaMediosPagoConverter = {
    toFirestore(mediosPago) {
        return mediosPago;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            nombre: data.nombre,
            camposExtra: data.camposExtra,
            activo: data.activo,
            ultimaEdicion: data.ultimaEdicion
        };
    }
};
exports.cajaMediosPagoConverter = cajaMediosPagoConverter;
function validateCajaMediosPago(obj) {
    if (typeof obj.version !== 'number') {
        throw new Error('Invalid property in CajaMediosPago: version should be a number');
    }
    if (typeof obj.id !== 'string') {
        throw new Error('Invalid property in CajaMediosPago: id should be a string');
    }
    if (typeof obj.nombre !== 'string') {
        throw new Error('Invalid property in CajaMediosPago: nombre should be a string');
    }
    if (typeof obj.requiereVencimiento !== 'boolean') {
        throw new Error('Invalid property in CajaMediosPago: requiereVencimiento should be a boolean');
    }
    if (!Array.isArray(obj.camposExtra)) {
        throw new Error('Invalid property in CajaMediosPago: camposExtra should be an array');
    }
    obj.camposExtra.forEach((campo) => validateCajaMediosPagoCampoExtra(campo));
    if (typeof obj.activo !== 'boolean') {
        throw new Error('Invalid property in CajaMediosPago: activo should be a boolean');
    }
    if (typeof obj.ultimaEdicion !== 'number') {
        throw new Error('Invalid property in CajaMediosPago: ultimaEdicion should be a number');
    }
}
exports.validateCajaMediosPago = validateCajaMediosPago;
function validateCajaMediosPagoCampoExtra(obj) {
    if (typeof obj.tipo !== 'string') {
        throw new Error('Invalid property in CajaMediosPagoCampoExtra: tipo should be a string');
    }
    if (typeof obj.nombre !== 'string') {
        throw new Error('Invalid property in CajaMediosPagoCampoExtra: nombre should be a string');
    }
    if (!Array.isArray(obj.opciones) || !obj.opciones.every((opcion) => typeof opcion === 'string')) {
        throw new Error('Invalid property in CajaMediosPagoCampoExtra: opciones should be an array of strings');
    }
    if (typeof obj.obligatorio !== 'boolean') {
        throw new Error('Invalid property in CajaMediosPagoCampoExtra: obligatorio should be a boolean');
    }
}
exports.validateCajaMediosPagoCampoExtra = validateCajaMediosPagoCampoExtra;
